import api from 'ApiConfig';

const announcementServices = {
  // What the logged in staff member is allowed to announce to.
  getTargets: async () => {
    return api.get('/announcement/targets');
  },
  // Course -> batch structure -> batch, for picking a batch to announce to.
  listCourses: async (branch) => {
    return api.get('/announcement/courses', { params: { branch } });
  },
  listBatchStructures: async (courseId) => {
    return api.get('/announcement/batch-structures', { params: { courseId } });
  },
  listBatches: async (courseId, batchStructureId, branch) => {
    return api.get('/announcement/batches', {
      params: { courseId, batchStructureId, branch },
    });
  },
  create: async (data) => {
    return api.post('/announcement/create', data);
  },
  list: async (params = {}) => {
    return api.get('/announcement/list', { params });
  },
  update: async (id, data) => {
    return api.put(`/announcement/${id}`, data);
  },
  remove: async (id) => {
    return api.delete(`/announcement/${id}`);
  },
};

export default announcementServices;
